import { useRef } from 'react';
import { useSalesOrderWorkspaceStore } from '../../store/salesOrderWorkspaceStore';

interface Props {
  master: React.ReactNode;
  detail: React.ReactNode;
}

// Two-pane resizable layout. Master (list) left, detail (compose form) right.
// Master is fixed-width pixels (clamped 290-330px in the store) so the list
// reads predictably regardless of viewport. Mirrors QuotationWorkspaceLayout.

export function SalesOrderWorkspaceLayout({ master, detail }: Props) {
  const masterPanelWidthPx = useSalesOrderWorkspaceStore((s) => s.masterPanelWidthPx);
  const setMasterPanelWidthPx = useSalesOrderWorkspaceStore((s) => s.setMasterPanelWidthPx);
  const splitRef = useRef<HTMLDivElement>(null);

  const handleDragStart = (e: React.MouseEvent) => {
    e.preventDefault();
    const container = splitRef.current;
    if (!container) return;
    const rect = container.getBoundingClientRect();

    const onMove = (ev: MouseEvent) => {
      setMasterPanelWidthPx(ev.clientX - rect.left);
    };
    const onUp = () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    };

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';
  };

  return (
    <div ref={splitRef} className="flex h-full min-h-0 w-full">
      <div
        className="relative flex min-w-0 flex-col border-r"
        style={{ flex: `0 0 ${masterPanelWidthPx}px` }}
      >
        {master}
      </div>
      <div
        onMouseDown={handleDragStart}
        className="w-1 shrink-0 cursor-col-resize bg-border transition-colors hover:bg-primary/30"
        aria-hidden
      />
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="min-h-0 flex-1">{detail}</div>
      </div>
    </div>
  );
}
